export function logoutToSleekSignPlatform(domain, callback) {
  // If domain is undefined, prevent loading of iframe
  if (!domain) {
    callback();
    return;
  }

  let iframe = document.getElementById("app_iframe");
  iframe.onload = () => {
    let win;
    try {
      win = iframe.contentWindow;
    } catch (e) {
      win = iframe.contentWindow;
    }
    let payload = {
      action: "Logout",
      isSleekPayload: true,
    };
    // save obj in subdomain localStorage
    win.postMessage(JSON.stringify({ key: "storage", method: "set", data: payload }), "*");

    callback();
  };
  iframe.src = domain;
}
